import { configureStore, combineReducers } from "@reduxjs/toolkit";
import appReducer from "slices/app/appSlice";
import modalsReducer from "slices/app/modalsSlice";
import errorReducer from "slices/app/errorSlice";
import userAdminReducer from "slices/userAdmin/userAdminSlice";
import systemAdminReducer from "slices/systemAdmin/systemAdminSlice";
import dictionariesReducer from "slices/dictionary/dictionarySlice";
import activeTabReducer from "slices/settings/slices/activeTabSlice";
import acronymIgnoreReducer from "slices/settings/slices/acronymIgnoreSlice";
import discoveryIgnoreReducer from "slices/settings/slices/discoveryIgnoreSlice";
import readabilityIgnoreReducer from "slices/settings/slices/readabilityIgnoreSlice";
import thresholdsReducer from "slices/settings/slices/thresholdsSlice";
import discoveryReducer from "slices/discovery/discoverySlice";
import dictionarySearchReducer from "slices/dictionarySearch/dictionarySearchSlice";

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: {
      app: appReducer,
      modals: modalsReducer,
      error: errorReducer,
      userAdmin: userAdminReducer,
      systemAdmin: systemAdminReducer,
      dictionaries: dictionariesReducer,
      discovery: discoveryReducer,
      dictionarySearch: dictionarySearchReducer,
      settings: combineReducers({
        activeTab: activeTabReducer,
        acronymIgnore: acronymIgnoreReducer,
        discoveryIgnore: discoveryIgnoreReducer,
        readabilityIgnore: readabilityIgnoreReducer,
        thresholds: thresholdsReducer,
      }),
    },
    preloadedState,
  });
};

export const store = setupStore();
